import { ofType } from 'redux-observable';
import { map, switchMap } from 'rxjs/operators';
import JobProApi from '../../dependencies/JobProApi';

// Action types
const UPDATE_JOB = 'UPDATE_JOB';
const UPDATE_JOB_COMPLETE = 'UPDATE_JOB_COMPLETE';

// Action creators
export const updateJob = (jobId, changes) => ({
  type: UPDATE_JOB,
  payload: { jobId, changes }
});

const updateJobComplete = (job) => ({
  type: UPDATE_JOB_COMPLETE,
  payload: job
});

// Epics
export const updateJobEpic = (action$) => action$.pipe(
  ofType(UPDATE_JOB),
  map(({ payload }) => payload),
  switchMap(({ jobId, changes }) => JobProApi.jobs.update(jobId, changes)),
  map(updateJobComplete)
);
